import classNames from 'classnames';
import React, { useCallback, useState } from 'react';
import { Button } from 'react-bootstrap';
import AuthorizedAction, {
  isAuthorized,
} from '../../../../AuthorizedAction.js';
import SubHeader from '../../../../SubHeader.jsx';
import RightArrowIcon from '../../../../icons/RightArrowIcon.jsx';
import CustomTooltip from '../../../../CustomTooltip.jsx';
import QuestionBlueIcon from '../../../../icons/QuestionBlueIcon.jsx';
import CustomSurveyTemplatesTable from '../CustomSurveyTemplatesTable.jsx';
import { PlusButtonIcon } from '../../../../icons/PlusButtonIcon.jsx';
import styles from './ChangeInsightTemplatesAccordion.module.css';

const ChangeInsightTemplatesAccordion = ({
  type,
  items,
  onShowModal,
  onAdd,
  tooltipContent,
  permissions,
}) => {
  const [surveyTemplatesHidden, setSurveyTemplatesHidden] = useState(true);

  const toggleSurveyTemplates = useCallback((e) => {
    e.preventDefault();
    setSurveyTemplatesHidden((hidden) => !hidden);
  }, []);

  const tableContainerId = `${type}InitiativesTableContainer`;
  const typeCapitalized = type;

  const className = classNames(styles.initiativesSection, {
    [styles.initiativesHidden]: surveyTemplatesHidden,
  });

  let totalCountCategories = 0;

  totalCountCategories = items.filter((i) => !i.archived).length;

  const checkAuthorize = isAuthorized('update', 'surveyTemplate', permissions);

  return (
    <section className={className}>
      <SubHeader flexJustify small accordion>
        <div className={styles.categoriesHeading}>
          <div className="flex row">
            <h2 style={{ marginLeft: '26px' }}>
              <a
                aria-controls={tableContainerId}
                aria-expanded={!surveyTemplatesHidden}
                className="flex"
                href="components/organizations/Settings/ChangeInsightTemplates/ChangeInsightTemplatesAccordion#"
                onClick={toggleSurveyTemplates}
                role="button"
              >
                <RightArrowIcon className="collapse-caret" />
                <span className={styles.initiativeType}>{typeCapitalized}</span>
              </a>
            </h2>
            <strong className="bordered text-muted">
              Total:&nbsp;
              <span className="text-info-brand count">
                {totalCountCategories}
              </span>
            </strong>
            {tooltipContent ? (
              <CustomTooltip
                placement="right"
                tooltip={
                  <div style={{ maxWidth: '256px' }}>
                    <strong>
                      <h5
                        style={{
                          fontSize: '14px',
                          fontWeight: '600',
                          lineHeight: '20px',
                          color: '#153142',
                        }}
                        className="m-b-8"
                      >
                        ChangeInsights Hub
                      </h5>
                    </strong>
                    <p
                      style={{
                        fontSize: '12px',
                        fontWeight: '400',
                        lineHeight: '20px',
                        color: '#7F8FA4',
                      }}
                      className="m-b-0 text-muted"
                    >
                      {tooltipContent}
                    </p>
                  </div>
                }
                id="tooltip"
              >
                <Button
                  aria-label="View Support for Change modal"
                  type="button"
                  className="flex flex-align-center m-l-8 btn-last-update-icon"
                >
                  <QuestionBlueIcon />
                </Button>
              </CustomTooltip>
            ) : null}
          </div>
          <div>
            <AuthorizedAction action="manage" subject="surveyTemplate">
              <Button bsStyle="success" onClick={onAdd}>
                <PlusButtonIcon />
                Add Feedback Form
              </Button>
            </AuthorizedAction>
          </div>
        </div>
      </SubHeader>
      <div id={tableContainerId}>
        {!surveyTemplatesHidden ? (
          <CustomSurveyTemplatesTable
            checkAuthorize={checkAuthorize}
            surveyTemplates={items}
            initiativeType={type}
            onShowModal={onShowModal}
          />
        ) : null}
      </div>
    </section>
  );
};

export default ChangeInsightTemplatesAccordion;
